import React, { useState } from 'react';
import { Select as AntdSelect, SelectProps as AntdSelectProps, Checkbox, Divider} from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { DefaultOptionType } from 'antd/es/select';

interface SelectProps extends AntdSelectProps {
  allowSelectAll?: boolean;
}

const Select: React.FC<SelectProps> = ({allowSelectAll, ...props }) => {
  const [searchValue, setSearchValue] = useState('')
  const {value, options = []} = props

  const handleSelectAll = (event: CheckboxChangeEvent) => {
    const newValue: [any[], DefaultOptionType[]] = event.target.checked ? [options.map(({value}) => value), options] : [[],[]]

    props.onChange?.(...newValue)
  }

  const customProps: Partial<SelectProps> = allowSelectAll && props.mode === 'multiple' ? {
    autoClearSearchValue: false,
    searchValue,
    onSearch: setSearchValue,
    dropdownRender(menu: any) {
      if (searchValue) {
        return menu
      }
      return (
        <>
          <Checkbox className='px-3 pt-2'
            checked={value?.length === options.length}
            indeterminate={value?.length > 0 && value?.length < options.length}
            onChange={handleSelectAll}
          >
            Select all
          </Checkbox>
          <Divider className='my-2' />
          {menu}
        </>
      )
    }
  } : {}
  return (
    <AntdSelect {...props} {...customProps} />
  );
};

export default Select;


